// extracted by mini-css-extract-plugin
export default {"price":"S8-z","onSale":"T8-z","msrpLabelPrice":"U8-z","msrpLabel":"V8-z","originalPrice":"W8-z","percentOff":"X8-z"};